export default {
  'Рекомендации': 'recommendations',
  title: {
    segments: 'Сегменты',
    attributes: 'Атрибуции'
  },
  color_switcher: {
    dark: 'Темный',
    light: 'Светлый'
  },
  routes: {
    product_recommendations: 'Товарные рекомендации',
    recommendations: 'Рекомендации',
    bisness_rules: 'Бизнес правила',
    new_business_rules: 'Новое бизнес правило',
    instruments: 'Инструменты',
    web_push: 'Web Push',
    pipeline: 'Сценарии',
    pipeline_hint: 'Редактор сценариев: цепочки писем, пушей и условий.',
    authorization: 'Авторизация',
    desktop: 'Рабочий стол',
    personal_area: 'Личный кабинет',
    multilead: 'Мультилид',
    lead: 'Карта лида',
    leads: 'Лиды',
    allleads: 'Все лиды',
    statistic: 'Статистика',
    visits: 'Визиты',
    visit: 'Визит',
    cart: 'Корзины',
    letters: 'Письма',
    forms: 'Формы',
    segments: 'Сегменты',
    editing: 'Редактирование',
    assortment: 'Ассортимент',
    allemails: 'Все рассылки',
    autocast: 'Авторассылки',
    editing_autocast: 'Редактирование авторассылки',
    create_autocast: 'Создание авторассылки',
    emails: 'Рассылки',
    create_email: 'Создать рассылку',
    auto_emails: 'Авторассылки',
    widgets: 'Виджеты',
    emails_templates: 'Шаблоны рассылок',
    emails_template: 'Шаблон рассылок',
    promotional_codes: 'Промокоды',
    reports: 'Отчеты',
    all_orders: 'Все заказы',
    сustomer_orders: 'Заказы клиентов',
    analytics: 'Аналитика',
    analytics_leads: 'Аналитика по клиентам',
    analytics_visits: 'Аналитика по визитам',
    analytics_emails: 'Аналитика по рассылкам',
    analytics_widgets: 'Аналитика по виджетам',
    analytics_recommendations: 'Аналитика по рекомендациям',
    analytics_emails_dynamics: 'Аналитика по динамике email',
    analytics_autocasts: 'Аналитика по авторассылкам',
    analytics_sales_funnel: 'Аналитика по воронке продаж',
    analytics_sales: 'Аналитика по продажам',
    analytics_offers: 'Аналитика по товарам',
    analytics_rfm: 'RFM-Анализ',
    offers: 'Товары',
    kpi_store: 'KPI магазина',
    average_check: 'Средний чек',
    paid_offers_rate: 'Исполняемость заказов',
    purchase_rate: 'Частота покупок',
    returned_customers: 'Коэфициент повторных клиентов',
    library: 'Библиотека',
    image: 'Изображения',
    integration: 'Интеграция',
    settings: 'Настройки',
    settings_account: 'Настройки аккаунта',
    change_password: 'Смена пароля',
    settings_alerts: 'Настройки оповещений',
    sites_list: 'Список сайтов',
    users: 'Пользователи',
    tool_management: 'Управление инструментами',
    timeline: 'Timeline',
    efficiency_leadhit: 'Эффективность LeadHit',
    site_forms: 'Формы сайта'
  },
  side_menu: {
    by_visits: 'По визитам',
    by_leads: 'По лидам',
    by_emails: 'По рассылкам',
    by_widgets: 'По виджетам',
    by_recommendations: 'По рекомендациям',
    by_emails_dynamic: 'По динамике email',
    by_autocasts: 'По авторассылкам',
    by_sales_funnel: 'По воронке продаж',
    by_sales: 'По продажам',
    app_language: 'Язык программы',
    app_languages: 'Языки программы',
    your_profile: 'Ваш профиль',
    profile_settings: 'Настройки профиля',
    my_sites: 'Мои сайты',
    my_users: 'Мои пользователи',
    by_efficiency_leadhit: 'По эффективности LeadHit',
    by_offers: 'По товарам',
    rfm_analysis: 'RFM-Анализ',
    consolidated_report: 'Сводный отчет'
  },
  mini_dashbord: {
    instruments_widgets:
      'В этом разделе собрали для вас все данные о работе виджетов на вашем сайте',
    instruments_message_campaings:
      'Отслеживайте эффективность массовых рассылок с помощью нашего сервиса аналитики',
    instruments_autocast:
      'Следите за работой ваших авторассылок и отслеживайте их результативность',
    leads_leads: 'Получите всю необходимую аналитику по собранной базе лидов за нужный период',
    leads_segments:
      'Сгруппируйте пользователей в различные сегменты, чтобы составить наилучшее товарное предложение для каждого',
    instruments_recommendations: 'Все активные и неактивные товарные рекомендации LeadHit',
    instruments_bisness_rules:
      'Список бизнес-правил, которые вы назначили для каждого товара вашего сайта',
    instruments_user_alerts:
      'Здесь собран полный список и история оповещений, которые вы настроили самостоятельно',
    library_image: 'Все загруженные вами изображения. Доступны для работы с инструментами сервиса',
    library_emails_templates: 'Полный список ваших активных и неактивных шаблонов для рассылок',
    library_promocodes: 'Полный список и статистика по вашим промокодам',
    reports_all_orders: 'Получите полную аналитику по заказам за нужный период',
    reports_recomendations:
      'Собирайте отчеты по эффективности рекомендаций за определённый период или за все время работы сервиса',
    reports_message_campaings:
      'Получайте все необходимые отчеты об эффективности массовых рассылок',
    reports_autocast: 'Получайте все необходимые отчеты об эффективности триггерных рассылок',
    efficiency_leadhit: 'Узнайте, сколько заказов принесла вам работа сервиса LeadHit',
    reports_sources_of_orders: 'Отслеживайте самые прибыльные источники заказов',
    instruments_loyalty_categories:
      'Категории лояльности, которые используются в работе сервиса LeadHit',
    instruments_loyalty_rules: 'Правила для определения категории лояльности'
  },
  confirm_leave_route: 'Вы уверены, что хотите покинуть страницу? Введенные данные будут потеряны.',
  confirm_widget_type_change: 'Вы уверены, что хотите изменить тип виджета? Дизайн и настройки текущего виджета будут потеряны.',
  receive: 'Получить',
  racoon_header_text: 'Добро пожаловать в личный кабинет компании LeadHit',
  equals: 'Равно',
  does_not_equal: 'Не равно',
  russian: 'Русский',
  english: 'Английский',
  deutsch: 'Немецкий',
  back: 'Назад',
  yes: 'Да',
  no: 'Нет',
  offer_title: 'Название',
  error_request_data: 'Ошибка запроса данных',
  error_sending_data: 'Ошибка отправки данных',
  error: 'Ошибка',
  lead: 'Лид',
  lead_email: 'Почта лида',
  lead_name: 'Имя лида',
  sign_in: 'Вход',
  registration: 'Регистрация',
  sign_up: 'Зарегистрироваться',
  enter_login: 'Введите логин',
  enter_password: 'Введите пароль',
  enter_email: 'Введите почту',
  enter_emails: 'Введите email',
  enter_phone: 'Введите телефон',
  enter_ammount: 'Введите сумму',
  confirm_processing_user_data: 'Настоящим, я даю согласие на обработку моих персональных данных',
  registration_password_error: 'Пароль должен быть минимум 8 символов',
  you_can_check_mail: 'Можно проверять почту',
  we_sent_information_to_mail: 'Мы отправили информацию на почту',
  i_forgot_password: 'Я забыл пароль',
  success_registration_confirm_message: 'Пользователь успешно зарегистрирован',
  enter_new_password: 'Введите новый пароль',
  password_success_updated: 'Пароль успешно обновлен',
  marketing_automation_service: 'Сервис автоматизации маркетинга',
  data_out_of_date: 'Данные устарели',
  repeat_confirm_registration_description:
    'Введите свой e-mail чтобы мы могли повторно отправить письмо для регистрации!',
  name: 'Имя',
  surname: 'Фамилия',
  add_1: 'Дополнительное поле 1',
  add_2: 'Дополнительное поле 2',
  add_3: 'Дополнительное поле 3',
  add_4: 'Дополнительное поле 4',
  add_5: 'Дополнительное поле 5',
  last_name: 'Фамилия',
  company: 'Компания',
  position: 'Должность',
  birthday: 'День рождения',
  email: 'Почта',
  emails_for_consolidated_report: 'Адрес электронной почты',
  sex: 'Пол',
  index: 'Почтовый индекс',
  country: 'Страна',
  region: 'Регион',
  city: 'Город',
  address: 'Адрес',
  sub_type: 'Тип подписки',
  discount_size: 'Размер скидки',
  order_id: 'Номер заказа',
  cart_sum: 'Сумма заказа',
  save: 'Сохранить',
  cancel: 'Отмена',
  add: 'Добавить',
  tool_setup: 'Настройка инструментов',
  no_data: 'Данные отсутствуют',
  apply: 'Применить',
  create: 'Создать',
  reset: 'Сбросить',
  show: 'Показать',
  hide: 'Скрыть',
  send: 'Отправить',
  choice: 'Выбор',
  choose_a_period: 'Выберите период',
  cost_per_period: 'Стоимость за период',
  delete_selected: 'Удалить выбранные',
  import: 'Импортировать',
  more_details: 'Подробнее',
  total: 'Всего',
  used: 'Использованно',
  alerts: 'Оповещения',
  remained: 'Осталось',
  start_typing: 'Начните ввод',
  uploaded: 'Загружено',
  download: 'Загрузить',
  generate: 'Сгенерировать',
  edit: 'Редактировать',
  delete: 'Удалить',
  activate: 'Активировать',
  deactivate: 'Деактивировать',
  select_from_list: 'Выбрать из списка',
  from_list: 'Из списка',
  select_all: 'Выделить все',
  password: 'Пароль',
  phone: 'Телефон',
  fax: 'Факс',
  timed_out: 'Время ожидания истекло',
  version: 'Версия',
  close: 'Закрыть',
  align: 'Выровнять',
  copy: 'Скопировать',
  time: 'Время',
  hours: '{n} час | {n} часа | {n} часов',
  minutes: '{n} минута | {n} минуты | {n} минут',
  pcs: 'шт',
  minute: 'минуты',
  amount_total: 'Сумма, итого',
  select: 'Выбрать',
  date: 'Дата',
  category: 'Категория',
  categories: 'Категории',
  logout: 'Выйти',
  product_introduction: 'Знакомство с продуктом',
  choose_site: 'Выбрать сайт',
  switch_language: 'Переключить язык',
  toggle_color_theme: 'Переключить цветовую тему',
  no_sites_available: 'Нет доступных сайтов',
  segment: 'Сегмент',
  group: 'Группа',
  descending: 'По убыванию',
  ascending: 'По возрастанию',
  data_successfully_sent_to_email: 'Данные успешно отправлены на почту',
  choose_all: 'Выбрать все',
  update: 'Обновить',
  misc: 'Дополнительная информация',
  loyalty_system: 'Система лояльности',
  bonus_points: 'Количество бонусов',
  desktop: {
    weekly_sales_funnel: 'Воронка продаж за неделю',
    shown: 'Показывается',
    widgets_are_active: 'Виджеты активны',
    widgets_count: '{n} виджет | {n} виджета | {n} виджетов',
    orders_per_week: 'Заказы за неделю',
    visits_per_week: 'Данные по визитам за неделю',
    with_leadhit: 'с LeadHit',
    earned: 'Заработано',
    earned_with_leadhit: 'Заработано с LeadHit',
    percentage_of_income_from_using_LeadHit: 'Процент дохода от использования LeadHit'
  },
  auth: {
    entered_parameters_incorrect: 'Введенные данные неверны',
    everything_is_ready: 'Все готово',
    check_inbox_mobile_text_first: 'Мы отправили Вам',
    check_inbox_mobile_text_second: 'информацию на почту',
    marketing_automation: 'Автоматизация маркетинга',
    too_many_attempts_try_again_later: 'Слишком много попыток, повторите позднее',
    not_a_valid_email_address: 'Некорректный e-mail адрес'
  },
  information: 'Информация',
  status: 'Статус',
  settings: {
    total_offers_count: 'Всего офферов',
    unavailable_offers_count: 'Недоступно офферов',
    spf_correct: 'SPF запись установлена корректно',
    spf_not_correct: 'SPF запись установлена некорректно',
    the_domain_should_look_like_this: 'Домен должен выглядеть таким образом',
    failed_to_load_feed: 'Не удалось загрузить фид',
    send_information_to_the_developer: 'Отправить информацию своему разработчику',
    send_all: 'Отправить все',
    enter_feed_link: 'Введите ссылку на фид',
    tracker_code_connected: 'Код счетчика подключен',
    order_code_connected: 'Код заказа подключен',
    tracker_code_not_connected: 'Код счетчика не подключен',
    order_code_not_connected: 'Код заказа не подключен',
    get_order_code: 'Получить код заказа',
    get_tracker_code: 'Получить код счетчика',
    order_code: 'Код заказа',
    webpush_sw_file: 'Файл для Web Push уведомлений',
    tracker_code: 'Код счетчика',
    update_offers_via_file_feed: 'Обновлять товары из файла фида',
    are_you_sure_you_want_to_delete_the_feed: 'Вы уверены что хотите удалить фид?',
    write_to_tech_support: 'Написать в техподдержку',
    feed_not_added: 'Фид не подключен',
    feed_added: 'Фид подключен',
    upload_feed: 'Загрузить фид',
    change_feed: 'Изменить фид',
    delete_feed: 'Удалить фид',
    technical_account_settings: 'Технические настройки аккаунта',
    get_weekly_reports: 'Получать еженедельные отчёты',
    new_password: 'Новый пароль',
    turn_off_all: 'Выключить все',
    turn_on_all: 'Включить все',
    product_alerts: 'Оповещения о продукте',
    invoice_alerts: 'Оповещения о счетах',
    service_alerts: 'Сервисные оповещения',
    commercial_alerts: 'Коммерческие оповещения',
    add_domain: 'Добавить домен',
    add_site: 'Добавить сайт',
    enter_domain_URL: 'Введите URL домена',
    enter_feed_URL: 'Введите URL фида',
    site_successfully_created: 'Сайт успешно создан',
    error_creating_site: 'Ошибка создания сайта',
    activity: 'Активность',
    add_user: 'Добавить пользователя',
    login: 'Логин',
    mail: 'Почта',
    domain: 'Домен',
    domain_name: 'Название домена',
    date_added: 'Дата добавления',
    feed: 'Фид',
    feed_name: 'Название фида',
    edit_domain: 'Редактировать домен',
    no_need_update_data: 'Нет необходимости обновления данных',
    site_successfully_updated: 'Сайт успешно обновлен',
    site_id: 'ID сайта',
    technical_settings_of_service: 'Технические настройки сервиса',
    technical_settings: 'Технические настройки',
    information_sent_to_your_developer: 'Информация отправлена Вашему разработчику',
    link_for_collecting_forms_on_the_site: 'Ссылка для сбора форм на сайте',
    block_banner: 'Блокировать баннер',
    subscription: 'Подписка',
    cart_form: 'Форма корзины',
    final_order_form: 'Финальная форма заказа',
    block_banner_hint: 'После заполнения формы баннер не будет показываться',
    cart_form_hint:
      "После заполнения формы баннер не будет показываться и статус визита становится 'Начало заказа'",
    final_order_form_hint:
      "После заполнения формы баннер не будет показываться и статус визита становится 'Заказ'",
    form_settings: 'Настройки форм',
    site_categories: 'Категории товаров',
    site_categories_description: 'Управление категориями товаров для рассылки "Брошенная категория"',
    upload_categories_file: 'Загрузка категорий из файла',
    file_requirements: 'Требования к файлу: Разделитель столбцов - точка с запятой. Заголовки столбцов: name, url, id.',
    select_csv_file: 'Выбрать CSV файл',
    selected_file: 'Выбран файл:',
    upload_categories: 'Загрузить категории',
    uploading: 'Загрузка...',
    add_category: 'Добавить категорию',
    category_name: 'Название категории:',
    category_name_placeholder: 'Введите название категории',
    category_url: 'URL категории:',
    category_url_placeholder: 'https://example.com/category',
    yml_category_id: 'YML ID категории:',
    yml_category_id_placeholder: 'Введите YML ID',
    adding: 'Добавление...',
    category_settings: 'Настройки категорий',
    url_params_title: 'Ключевые параметры в URL категорий',
    url_params_label: 'Параметры (через запятую):',
    url_params_placeholder: 'utm_source, utm_medium, ref',
    save_params: 'Сохранить параметры',
    categories_list: 'Список категорий',
    refresh: 'Обновить',
    delete_all: 'Удалить все',
    loading_categories: 'Загрузка категорий...',
    no_categories: 'Категории не найдены',
    actions: 'Действия',
    delete: 'Удалить',
    confirm_delete_category: 'Вы уверены, что хотите удалить эту категорию?',
    delete_category: 'Удаление категории',
    confirm_delete_all_categories: 'Вы уверены, что хотите удалить все категории?',
    delete_all_categories: 'Удаление всех категорий',
    delete_all_warning: 'Это действие нельзя отменить. Все категории будут удалены безвозвратно.',
    category_uploaded: 'Категории успешно загружены',
    category_added: 'Категория успешно добавлена',
    category_updated: 'Категория успешно обновлена',
    category_deleted: 'Категория успешно удалена',
    all_categories_deleted: 'Все категории успешно удалены',
    url_params_saved: 'Параметры URL сохранены',
    upload_error: 'Ошибка при загрузке файла',
    add_error: 'Ошибка при добавлении категории',
    update_error: 'Ошибка при обновлении категории',
    delete_error: 'Ошибка при удалении категории',
    delete_all_error: 'Ошибка при удалении всех категорий',
    save_params_error: 'Ошибка при сохранении параметров',
    select_csv_error: 'Пожалуйста, выберите CSV файл',
    search_placeholder: 'Поиск по названию',
    delete_selected: 'Удалить выбранные',
    delete_selected_categories: 'Удалить выбранные категории',
    confirm_delete_selected_categories: 'Вы уверены, что хотите удалить выбранные категории?',
    selected_categories_deleted: 'Выбранные категории успешно удалены',
    delete_selected_error: 'Ошибка при удалении выбранных категорий',
    update_form_setting_question: 'Вы уверены, что хотите обновить форму',
    form_updated_successfully: 'Форма обновлена успешно',
    form_update_error: 'Ошибка обновления формы',
    choose_tariff: 'Выберите тариф',
    users: {
      user_name: 'Имя пользователя',
      role: 'Роль',
      sites: 'Сайты',
      editing: 'Редактирование',
      delete: 'Удаление',
      manager: 'Менеджер',
      guest: 'Гость',
      title_for_input_username:
        'Вы можете использовать только латинские символы, цифры и нижние подчеркивание',
      invalid_login: 'Неверный логин',
      re_enter_password: 'Введите пароль повторно',
      passwords_do_not_match: 'Пароли не совпадают',
      invalid_email: 'Почта некорректна',
      confirm_password: 'Подтвердите пароль',
      email: 'Электронная почта',
      choose_role: 'Выберите роль',
      choose_site: 'Выберите сайт',
      you_edited_data: 'Вы отредактировали данные',
      delete_user: 'Удаление пользователя',
      add_new_user: 'Добавление нового пользователя',
      user_data_updated_successfully: 'Данные пользователя успешно обновлены',
      you_sure_want_delete_user: 'Вы действительно хотите удалить пользователя',
      user_will_be_deleted: 'Удаляемый пользователь',
      user_successfully_deleted: 'Пользователь успешно удален',
      user_created_successfully: 'Пользователь успешно создан',
      no_changes: 'Изменений нет',
      please_select_at_least_one_site: 'Пожалуйста, выберите хотя бы один сайт',
      block: 'Заблокировать',
      active: 'Активный'
    }
  },
  notifications: {
    need_soft_redirect:
      'Для обновления версии кабинета, пожалуйста, выполните повторный вход в аккаунт',
    notifications_count: '{n} оповещение | {n} оповещения | {n} оповещений',
    you_have: 'У Вас',
    notifications: 'Оповещения'
  },
  timeline: {
    visit_start: 'Начало визита',
    visit_end: 'Конец визита',
    page_visit: 'Открыл страницу',
    cart_item: 'Добавил товар',
    email_clicked: 'Перешел из письма',
    email_delivered: 'Получил рассылку',
    email_opened: 'Открыл письмо',
    widget_popup_view: 'Увидел всплывающее окно с виджетом',
    widget_fill: 'Заполнил виджет',
    widgets_close: 'Закрыл виджет',
    recommendation_click: 'Клик по рекомендуемому товару',
    webpush_shown: 'Увидел веб-пуш',
    webpush_clicked: 'Кликнул по веб-пушу',
    webpush_closed: 'Закрыл веб-пуш',
    webpush_dismissed: 'Закрыл веб-пуш',
    form: 'Заполнил форму',
    order: 'Оформил заказ',
    default: 'Неизвестное событие',
    select_options_to_filter: 'Выберите параметры для фильтрации',
    this_field_displays_the_selected_filters: 'В данном поле отобразятся выбранные фильтры',
    total_events: 'Всего событий',
    pages_visited: 'Посещено страниц',
    completed_forms: 'Заполнено форм',
    received_emails: 'Получено писем',
    orders_made: 'Совершено покупок',
    there_are_no_events_for_the_selected_period: 'Нет событий за выбранный период',
    no_options_to_display: 'Не выбраны параметры для фильтрации'
  },
  all_leads: {
    double_opt_in: 'Согласие на получение рассылок',
    no_leads_with_provided_status: 'Нет лидов с таким статусом',
    leads_statuses_changed_success: 'Статусы лидов успешно заменены',
    choose_both_statuses: 'Выберите оба статуса',
    statuses_cant_be_the_same: 'Статусы не могут быть одинаковыми',
    date_of_appearance: 'Дата появления',
    list_of_all_leads: 'Список всех лидов',
    no_name: 'Имя отсутствует',
    no_email: 'Email отсутствует',
    lead_import: 'Импорт лидов',
    change_lead_status: 'Изменение статуса лидов',
    overwrite_existing_lead_values: 'Перезаписывать значения существующих лидов',
    you_can_upload_csv_file_with_leads: 'Вы можете загрузить csv файл с лидами',
    information_about_csv_file_format: 'Информация о формате csv файла',
    no_file_selected: 'Файл не выбран',
    file_size_is_too_large: 'Размер файла больше допустимого',
    number_of_successfully_loaded_leads: 'Количество успешно загруженных лидов',
    number_of_existed_leads: 'Количество существующих лидов',
    number_of_overwritten_leads: 'Количество перезаписанных лидов',
    number_of_errors: 'Количество ошибок',
    import_example: {
      name: 'Иван',
      surename: 'Петров',
      phone: '+79999999999',
      country: 'Россия',
      city: 'Москва',
      address: 'ул.Пушкина, д.1',
      sex: 'М/Ж',
      status: 'Новый/Контакт/Лид/Менеджер/Постоянный/Оптовый'
    },
    import_rules: {
      semicolon_must_be_used_as_separator:
        'В качестве разделителя необходимо использовать точку с запятой (;)',
      default_status: 'Если вы не укажете статус лида - ему будет выставлен статус Новый',
      required_and_optional_field: 'Основное поле - email, остальные заполнять не обязательно',
      table_example: 'Заголовки столбцов должны быть точно как в примере'
    },
    lead: {
      imported: 'Импортирован',
      contact_details: 'Контактные данные',
      personal_data: 'Личные данные',
      contact_information: 'Контактная информация',
      unsubscribe: 'Отписать',
      unsubscribe_from_autocasts: 'Отписаться от авторассылок',
      unsubscribe_from_emails: 'Отписаться от массовых рассылок',
      unsubscribe_from_all_newsletters: 'Отписаться от всех рассылок',
      all_visits: 'Все визиты',
      total_visits: 'Всего визитов',
      visit_status: 'Статус визита',
      technical_data: 'Технические данные',
      postcode: 'Почтовый индекс',
      country: 'Страна',
      region: 'Регион',
      city: 'Город',
      city_of_last_visit: 'Город последнего визита',
      country_of_last_visit: 'Страна последнего визита',
      device: 'Устройство',
      os: 'Система',
      browser: 'Браузер',
      viewed_categories: 'Просмотренные категории',
      viewed_offers: 'Просмотренные товары',
      wished_items: 'Желаемые товары',
      recommended_items: 'Рекомендованные товары',
      number_views: 'Количество просмотров',
      purchased_goods: 'Выкупленные товары',
      visit_page: 'Посещение страницы',
      add_to_cart: 'Добавление в корзину',
      date_of_completion: 'Дата заполнения',
      last_step_of_cart: 'Последний шаг корзины',
      fill_URL: 'URL заполнения',
      subscription_settings_changed: 'Настройки подписок измененны',
      subscription_settings_not_changed: 'Настройки подписок не изменились',
      subscription_update_failed: 'Ошибка обновления подписок',
      edit_lead_summary_title: 'Редактирование информации о лиде',
      edit_lead_summary_question: 'Вы уверены что хотите сохранить изменения данных о лиде',
      error_lead_summary: 'Ошибка обновления данных о лиде',
      lead_summary_success_updated: 'Данные о лиде успешно обновлены',
      subscribe_info: 'Информация о подписке',
      status: {
        new: 'Новый',
        contacted: 'Контакт',
        customer: 'Клиент',
        manager: 'Менеджер',
        regular: 'Постоянный',
        wholesale: 'Оптовый'
      }
    }
  },
  segments: {
    segment_created: 'Сегмент создан',
    segment_updated: 'Сегмент обновлен',
    segments_deleted: 'Сегменты удалены',
    segment_deleted: 'Сегмент удален',
    segment_duplicate_error: 'Сегмент с таким именем уже существует',
    overwrite_import_leads_fields_error: 'Выберите хотя бы одно значение для перезаписи',
    lead_groups: 'Группы лидов',
    all_segments: 'Все сегменты',
    segment_name: 'Название сегмента',
    number_leads: 'Количество лидов',
    content: 'Содержание',
    select_segments: 'Выбрать сегменты',
    add_segment: 'Добавить сегмент',
    import_segment: 'Импортировать сегмент',
    segment_import: 'Импорт сегмента',
    delete_segments: 'Удаление сегментов',
    delete_segments_question: 'Вы уверены, что хотите удалить следующие сегменты?',
    male: 'Мужской',
    female: 'Женский',
    save_segment: 'Сохранение сегмента',
    appearance_time: 'Время появления',
    score: 'Рейтинг',
    completed_form: 'Заполненная форма',
    unsubscribed: 'Отписан',
    loaded: 'Загружен',
    lead_status: 'Статус лида',
    sent_mailing: 'Отправленная рассылка',
    order_date: 'Дата заказа',
    order_exists: 'Был совершен заказ',
    last_order_date: 'Дата последнего заказа',
    selected_filters_empty_placeholder: 'Здесь появятся выбранные фильтры',
    enter_segment_name: 'Введите название сегмента',
    save_segment_text: 'Сегмент будет сформирован по следующим параметрам',
    select_at_least_one_condition: 'Выберите как минимум одно условие',
    select_condition: 'Выберите условие',
    select_operator: 'Выберите оператор',
    sex: 'Пол',
    static_segment: 'Статичный сегмент',
    define_value: 'Определите значение',
    no_need_save_data: 'Нет необходимости сохранения данных',
    copy_segments: 'Копирование сегментов',
    copy_segments_text: 'Введите название новых сегментов',
    export: 'Экспорт',
    export_segments: 'Экспорт сегментов',
    segments_sent_to_your_email: 'Сегменты отправлены на Ваш e-mail',
    number_of_multilead_orders: 'Количество заказов мультилида',
    number_of_multilead_visits: 'Количество визитов мультилида',
    amount_of_multilead_orders: 'Сумма заказов мультилида',
    date_of_multilead_order: 'Дата заказа мультилида',
    date_of_last_site_visit: 'Дата последнего визита сайта',
    multilead_last_order_date: 'Дата последнего заказа мультилида',
    multilead_time_added: 'Дата появления мультилида',
    opened_mass_emails_by_last_n_days: 'Открывал массовые рассылки за последние N дней',
    recieved_mass_messages: 'Получал массовые рассылки',
    confirmed_double_opt_in: 'Дал согласие DOI'
  },
  image: {
    no_uploaded_images: 'У Вас нет загруженных изображений',
    max_image_size: 'Максимальный размер загружаемого изображения',
    acceptable_image_formats: 'Допустимые форматы изображений',
    drag_and_drop_files_to_upload: 'Перетащите файлы для загрузки',
    select_files: 'Выбрать файлы',
    image_upload: 'Загрузка изображения',
    all_uploaded_images: 'Все загруженные изображения',
    not_valid_image_message: 'Неверный формат файла(PNG/JPG) или превышен допустимый размер',
    images_successfully_uploaded: 'Изображения успешно загружены',
    upload_error: 'Ошибка загрузки изображений',
    load_error: 'Ошибка загрузки изображений',
    image_successfully_deleted: 'Изображение успешно удалено',
    delete_error: 'Ошибка удаления изображения',
    image_successfully_updated: 'Изображение успешно обновлено',
    update_error: 'Ошибка обновления изображения',
          url_copied_to_clipboard: 'URL скопирован в буфер обмена',
      copy_url: 'Копировать ссылку',
      copy_url_error: 'Ошибка копирования URL',
      loading_images: 'Загрузка изображений...'
  },
  integration: {
    api_text_generate: `Здесь вы можете сгенерировать ключ для работы с Leadhit через API Укажите его в заголовке POST-запроса с ключом 'API-KEY'`
  },
  emails_templates: {
    template_already_exists: 'Шаблон с таким названием уже существует',
    archive_template: 'Архивировать шаблоны рассылок',
    unarchive_template: 'Разархивировать шаблоны рассылок',
    archive_template_question: 'Вы уверены, что хотите архивировать выбранный шаблон | Вы уверены, что хотите архивировать выбранные шаблоны | Вы уверены, что хотите архивировать выбранные шаблоны',
    unarchive_template_question: 'Вы уверены, что хотите разархивировать выбранный шаблон | Вы уверены, что хотите разархивировать выбранные шаблоны | Вы уверены, что хотите разархивировать выбранные шаблоны',
    emails_template_has_been_archived: 'Шаблон был архивирован | Шаблоны были архивированны | Шаблоны были архиварованны',
    emails_template_has_been_unarchived: 'Шаблон был разархивирован | Шаблоны были разархивированны | Шаблоны были разархиварованны',
    show_archived_template: 'Показать шаблоны в архиве',
    name_template: 'Имя шаблона',
    channel: 'Канал',
    used_in_autocasts: 'Используется в авторассылках',
    active: 'Активен / Не активен',
    date_of_creation: 'Дата создания',
    delete_template: 'Удалить шаблон',
    copy_template: 'Копировать шаблон',
    confirm_popup_delete_body_text: 'Вы уверены, что хотите удалить выбранный шаблон',
    confirm_popup_copy_body_text: 'Вы уверены, что хотите копировать выбранный шаблон',
    name_selected_template: 'Название выбранного шаблона',
    template_deleted: 'Шаблон удален',
    error_deleting_template: 'Ошибка удаления шаблона',
    preview: 'Предпросмотр',
    create_new_email_template: 'Создание нового шаблона рассылок',
    stripo_editor: 'Редактор Stripo',
    code_editor: 'Редактор кода',
    webpush_editor: 'Веб-пуш',
    select_template_type_body_text_first: 'Выберите формат нового шаблона писем',
    select_template_type_body_text_second: 'Эти форматы несовместимы',
    select_template_type_body_text_third_first: 'Шаблон, сохраненный в Stripo,',
    select_template_type_body_text_third_second:
      'невозможно будет редактировать в обычном редакторе, и наоборот',
    enter_template_name: 'Введите название шаблона',
    copy_html: 'Скопировать HTML',
    template_saved_successfully: 'Шаблон успешно сохранен',
    error_save_template: 'Ошибка сохранения шаблона',
    code_copied_successfully: 'Код скопирован успешно',
    hidden_pre_title: 'Скрытый предзаголовок',
    preheader_description:
      'Скрытый текст, который будет отображен, как продолжение темы в еще не открытом письме почтовой программы',
    copy: 'Копировать',
    duplicate: 'Копия',
    export_email_template:
      'Экспорт шаблона рассылок | Экспорт шаблонов рассылок | Экспорт шаблонов рассылок',
    confirm_popup_export_body_text:
      'Вы уверены, что хотите экспортировать выбранный шаблон | Вы уверены, что хотите экспортировать выбранные шаблоны | Вы уверены, что хотите экспортировать выбранные шаблоны',
    name_of_selected_email_template:
      'Название выбранного шаблона рассылок | Название выбранных шаблонов рассылок | Название выбранных шаблонов рассылок',
    template_export_error: 'Ошибка экспорта шаблона',
    templates_export_error: 'Ошибка экспорта шаблонов',
    import: 'Импорт',
    import_email_templates: 'Импортировать шаблоны рассылок',
    overwrite_existing_templates: 'Перезаписать существующие шаблоны',
    file_format_should_be_html_or_mjml: 'Формат файлов должен быть html или mjml',
    error_reading_files: 'Ошибка чтения файлов',
    template_import_error: 'Ошибка импорта шаблонов',
    number_of_templates_imported_successfully: 'Количество успешно импортированных шаблонов',
    number_of_templates_not_imported: 'Количество не импортированных шаблонов',
    choose_template: 'Выбрать шаблон',
    download_preview: 'Скачать шаблон',
    copy_to_clipboard: 'Скопировать',
    go_to_template: 'Перейти в шаблон',
    cannot_delete_template_in_use: 'Нельзя удалить шаблон, который используется в авторассылке',
    template_used_in_autocasts: 'Шаблон используется в следующих авторассылках:'
  },
  promocodes: {
    category_name: 'Название категории',
    promo_code_name: 'Название промокода',
    remove_all_of_unused_promotional_codes: 'Удалить все неиспользованные промокоды',
    remove_all_promotional_codes_without_category: 'Удалить все промокоды без категории',
    for_all_time: 'За все время',
    promotion_codes_deleted: 'Удалено промокодов:',
    promotional_codes_uploaded: 'Загружено промокодов: ',
    rewritten_promo_codes: 'перезаписано промокодов: ',
    files_entries_that_already_in_the_database: 'уже существующих в БД: ',
    no_loyalty_categories_with_names: 'нет категорий лояльности с именами: ',
    removed: 'удален',
    select_file: 'Выберите файл',
    select_a_category_to_delete: 'Выберите категорию для удаления',
    email_must_be_different: 'E-mail должны быть разными',
    mail_for_alerts_updated: 'E-mail для оповещения обновлен',
    are_you_sure_you_want_to_keep_current_mail: 'Вы уверены что хотите сохранить текущий e-mail?',
    are_you_sure_you_want_to_delete_the_current_mail:
      'Вы уверены, что хотите удалить текущий e-mail?',
    delete_email_for_alerts: 'Удалить e-mail для оповещения',
    save_email_for_alerts: 'Сохранить e-mail для оповещения',
    search: 'Поиск',
    delete_everything: 'Удалить все',
    delete_promotional_codes: 'Удаление промокодов',
    remaining_promotional_codes: 'Оставшиеся',
    used_promotional_codes: 'Использованные',
    all_promotional_codes: 'Все промокоды',
    active_email: 'Действующий e-mail',
    enter_new_email: 'Введите новый e-mail',
    are_you_sure_you_want_to_remove_the_promotional_codes_from_the_category:
      'Вы уверены что хотите удалить промокоды из категории',
    are_you_sure_you_want_to_delete_all_promotional_codes:
      'Вы уверены что хотите удалить все промокоды?',
    date_of_download: 'Дата загрузки',
    are_you_sure_you_want_to_remove_the_promotional_code: 'Вы уверены, что хотите удалить промокод',
    overwrite_existing_ones_by_making_them_available:
      'Перезаписать существующие, сделав их доступными',
    import_promotional_codes: 'Импортировать промокоды',
    editing_mail_for_alerts: 'Редактирование почты для оповещений',
    promotion_code_text_email: 'Введите e-mail для оповещений, если у Вас закончились промокоды',
    promotion_code_statistics: 'Статистика по промокодам',
    remove_promotional_code: 'Удалить промокод',
    remove_promotional_codes: 'Удалить промокоды',
    promotional_code: 'Промокод',
    category: 'Категория',
    date_of_use: 'Дата использования',
    date_added_to_the_site: 'Дата добавления на сайт',
    download_statistics: 'Скачать статистику',
    download_promotional_codes: 'Скачать промокоды',
    download_instructions: 'Скачать инструкцию',
    the_file_format_must_be_csv: 'Формат файла должен быть csv',
    select_promocodes_to_download: 'Выберите типы промокодов для скачивания',
    download_promocodes: 'Скачать промокоды'
  },
  offers: {
    store_offers: 'Товары магазина',
    price: 'Цена',
    update_date: 'Дата обновления',
    vendor: 'Продавец',
    available: 'Имеется в наличии',
    description: 'Описание',
    model: 'Модель'
  },
  reports: {
    compare_selected: 'Сравнить выбранные',
    enter_one_or_several_emails: 'Укажите один или несколько email адресов через запятую',
    clicks: 'Клики',
    purchases: 'Покупки',
    attribution: 'Атрибуция',
    attributions: 'Атрибуции',
    by_orders: 'По заказам',
    leadhit_service_reports: 'Отчеты сервиса Leadhit',
    end_to_end_analytics: 'Сквозная аналитика',
    multi_report: 'Мультиотчет',
    download: 'Скачать',
    sources_of_orders: 'Источники заказов',
    statistics: 'Статистика',
    recommendations_report: 'Отчет по рекомендациям',
    consolidated_report: 'Сводный отчет',
    emails_report: 'Отчет по рассылкам',
    multichannel: 'Мультиканальный',
    split_into_groups: 'Разбить по группам',
    download_report: 'Скачать отчет',
    send_report_on_email: 'Отправить отчет на email',
    choose_filter: 'Выберите фильтр',
    recommendation_report_exclude_empty_data: 'Исключить из отчета заказы без номера или суммы',
    select_action: 'Выберите действие',
    autocasts_report: 'Отчет по авторассылкам',
    after_receiving_email: 'После получения письма',
    report_type: 'Тип отчета',
    mailings_type: 'Тип рассылок',
    leadhit_efficiency_report: 'Отчёт по эффективности LeadHit',
    active: 'Активные',
    inactive: 'Неактивные',
    channel: 'Канал',
    attribution_channel: 'Канал атрибуции',
    orders_amount: 'Сумма заказов',
    successfully_sent: 'Данные успешно отправленны',
    orders: {
      click_time: 'Время клика',
      order_number: 'Номер заказа',
      total_amount: 'Сумма',
      number: 'Номер',
      source: 'Источник',
      time_added: 'Дата оформления',
      order_sum: 'Сумма заказа',
      sum: 'Сумма',
      information_about_order: 'Информация о заказе',
      client: 'Клиент',
      product_list: 'Список товаров',
      no_products: 'Товары отсутствуют',
      amount: 'Количество',
      total_number_orders: 'Общее количество заказов',
      total: 'Итого',
      exclude_orders_without_number_or_amount: 'Исключить из отчета заказы без номера или суммы',
      display_unprocessed_order_amounts: 'Выводить необработанные суммы заказов',
      do_not_display_lead_orders_with_manager_status:
        'Не отображать заказы лидов со статусом "Менеджер"',
      source_grouping: 'Группировка по источникам'
    },
    diagram_order_count: 'Диаграмма по количеству заказов',
    diagram_total_sum: 'Диаграмма по общей сумме заказов',
    period_total: 'Итого за выбранный период',
    long_period_report: 'Формирование отчета',
    long_period_report_description: 'Формирование отчета за выбранный период может занять длительное время. Мы можем отправить его вам на почту после формирования.',
    enter_emails: 'Введите email адреса через запятую',
    invalid_email: 'Одна из указанных почт не валидна',
    incorrect_email: 'Некорректный email',
    report_will_be_sent_to_email: 'Отчет будет отправлен на указанную почту',
    report_will_be_sent_to_emails: 'Отчет будет отправлен на указанные почты',
  },
  analytic: {
    you_can_select_only_one_type_of_widget: 'Вы можете выбрать только один тип виджета!',
    you_can_select_only_one_widget: 'Вы можете выбрать только один виджет!',
    you_can_select_only_one_autocast: 'Вы можете выбрать только одну авторассылку!',
    you_can_select_only_one_widget_recommendation:
      'Вы можете выбрать только один виджет рекомендаций!',
    message_campaigns_selected: 'Выбрано 6 рассылок. Это максимальное количество!',
    by_leads: 'По лидам',
    traffic_source: 'Источник трафика',
    diagram: 'Диаграмма',
    channel_groups: 'Группы каналов',
    social_networks: 'Социальные сети',
    search_engines: 'Поисковые системы',
    advertising: 'Реклама',
    other: 'Другое',
    no_type: 'Нет типа',
    all_traffic: 'Весь трафик',
    compare_periods: 'Сравнить периоды',
    by_unique_events: 'По уникальным событиям',
    period: 'Период',
    total_per_period: 'Всего за период',
    choose_emails: 'Выберите рассылки',
    open_list: 'Открыть список',
    selection_widget_recommendations: 'Выбор виджета рекомендаций',
    recommendation_widget_analytics: 'Аналитика по виджетам рекомендаций',
    recommendation_widget_popup_title: 'Выберите один из виджетов рекомендаций',
    clicked_on_recommendations_widget: 'Кликнуло на виджет рекомендаций',
    order_sum_after_click_widget_recommendation: 'Сумма заказов после клика на виджет рекомендаций',
    orders_after_click_widget_recommendation: 'Заказов после клика на виджет рекомендаций',
    choose_widget: 'Выберите виджет',
    recommendations_data: 'Данные по рекомендациям',
    choose_recommendation_widget: 'Выберите виджет рекомендаций',
    lead_analytics: 'Аналитика по лидам',
    choose_autocast_by_name: 'Выберите авторассылку по названию',
    select_least_one_autocast: 'Выберите хотя бы одну авторассылку',
    total_sales: 'Продажи всего',
    total_revenue: 'Выручка общая',
    sales: 'Продажи',
    revenue_share: 'Доля выручки',
    store_sales: 'Собственные продажи',
    total_amount_orders: 'Общая сумма заказов',
    widget_analytics: 'Аналитика по виджету',
    choose_widget_name: 'Выберите название виджета',
    choose_widget_type: 'Выберите тип виджета',
    select_widget_type_to_compare: 'Выберите тип виджета для сравнения',
    choose_one_of_widgets_by_name: 'Выберите один из виджетов по названию',
    widget_data: 'Данные по виджетам',
    condition_receiving_data: 'Условие получения данных',
    other_sources: 'Другие источники',
    on_unique_visits: 'по уникальным визитам',
    on_unique_leads: 'по уникальным лидам',
    leads_unsubscribed_from_all_mailings: 'Количество клиентов, отписавшихся от всех рассылок',
    amount_of_new_leads: 'Количество новых клиентов',
    unsubscribed_discovered_leads_ratio: 'Количество отписавшихся клиентов / количество новых',
    total_sent: 'Количество отправленных писем',
    total_opened: 'Количество открытых писем',
    total_clicked: 'Количество кликов по ссылкам в письме',
    conversion: 'Конверсия',
    absolute_conversion: 'Абсолютная конверсия',
    goods_that_are_most_often_bought: 'Товары, которые чаще всего покупают',
    goods_that_are_most_often_added_to_cart_but_not_bought:
      'Товары, которые чаще всего добавляют в корзину, но не покупают',
    goods_that_are_most_often_viewed: 'Товары, которые чаще всего просматривают',
    goods_that_are_most_often_viewed_but_not_bought:
      'Товары, которые чаще всего просматривают, но не покупают',
    offer_name: 'Название товара',
    number_of_purchases: 'Покупки',
    number_of_cart_additions: 'Корзины',
    number_of_views: 'Просмотры',
    website_page: 'Страница на сайте',
    period_cannot_be_more_than_one_month: 'Период не может быть более одного месяца',
    kpi: {
      arpv_definition:
        'средняя стоимость каждого посещения, т.е. сколько рублей приносит в среднем один посетитель',
      revenue: 'Выручка',
      traffic_volume_visitor: 'Объём трафика (посетитель)',
      arpl_definition: 'средний доход с лида',
      traffic_volume_lids: 'Объём трафика (лиды)',
      arppu_definition: 'средний доход с одного клиента',
      customers_who_made_order: 'Клиенты, совершившие заказ',
      average_check_definition: 'средняя сумма заказа в вашем интернет-магазине',
      number_orders: 'Количество заказов',
      purchase_rate_definition: 'средняя частота покупки одного клиента',
      number_unique_customers: 'Количество уникальных клиентов',
      repeat_customer_rate_definition: 'процент клиентов, которые оформили больше 1 заказа',
      number_unique_multi_customers:
        'Количество уникальных клиентов, совершивших более одной покупки',
      car_definition: 'процент брошенных корзин',
      paid_offers_rate_definition: 'количество оформленных заказов на количество оплаченных',
      number_of_bookings_orders: 'Количество оформленных заказов',
      number_of_paid_orders: 'Количество оплаченных заказов',
      total_orders: 'Всего заказов',
      orders_completed: 'Исполнено заказов',
      income: 'Доход',
      orders: 'Заказы',
      carts: 'Корзины'
    },
    sales_funnel_chart: {
      total_visits: 'Посетили сайт',
      total_offer_views: 'Страницы товаров просмотрели',
      total_additions_to_cart: 'Добавили в корзину',
      total_orders_made: 'Сделали заказ'
    }
  },
  widget: {
    smart_offer: 'Смарт-оффер',
    smart_offer_mobile: 'Смарт-оффер-мобильный',
    social_proof: 'social-proof',
    subscribe: 'Подписка',
    wish_list: 'Вишлист',
    generic: 'Пользовательский',
    notification: 'Уведомление',
    recommendations: 'Рекомендации',
    coupon: 'Купон',
    wheel_of_fortune: 'Колесо фортуны',
    undefined: 'Неизвестный тип виджета',
    last_viewed: 'Просмотренные товары'
  },
  instruments: {
    update_statistic: 'Обновить статистику',
    update_statistic_request_success: 'Запрос на обновление статистики отправлен',
    no_delay: 'Сразу',
    started: 'Запущена',
    most_popular: 'Самые популярные',
    clicks: 'Кликов',
    open: 'Открыто',
    mailing_date: 'Дата рассылки',
    time_activated: 'Дата активации',
    delivered: 'Доставлено',
    sent: 'Отправлено',
    newsletter_name: 'Название рассылки',
    unsubscribed: 'Отписалось',
    complained: 'Пожаловались',
    last_activity: 'Последняя активность',
    new_mass_email_campaign: 'Создать рассылку',
    new_trigger_email_campaign: 'Создание авторассылки',
    autocast_name: 'Название авторассылки',
    email_template: 'Шаблон письма',
    sender_name: 'Имя отправителя',
    sender_address: 'Адрес отправителя',
    email_subject: 'Тема письма',
    dispatch_delay: 'Задержка отправки (минуты)',
    dispatch_interval: 'Интервал отправки (часы)',
    time_after_last_order: 'Интервал до последнего заказа (часы)',
    autocast_type: 'Тип рассылки',
    linked_widget: 'Связанный виджет (опционально)',
    do_not_send_emails: 'Не отправлять письма',
    confirmation_of_subscription_is_required_for_sending_autocast:
      'Для отправки авторассылки требуется подтверждение подписки',
    disable_the_banner_display_when_email_is_clicked:
      'Отключить показ баннера при переходе по письму',
    periodical: 'Периодическая',
    hour_of_dispatch: 'Час отправки',
    per_day_emails_upper_limit: 'Максимальное кол-во писем в день',
    delivery_days: 'Дни отправки',
    conditions: 'Условия',
    a_b_testing: 'А/Б тесты',
    add_a_test: 'Добавить тест',
    testing_name: 'Название тестирования',
    choose_autocast: 'Выберите авторассылку',
    choose_template: 'Выберите шаблон',
    more: 'Дополнительно',
    and: 'И',
    or: 'ИЛИ',
    contains: 'Содержит',
    does_not_contain: 'Не содержит',
    test_autocast: 'Тестовая рассылка',
    sending_time: 'Время отправки',
    chunk_size: 'Время отправки',
    interval_between_segments: 'Интервал между сегментами',
    provider: 'Провайдер',
    to: 'Кому',
    address: 'Адрес',
    list_name: 'Имя списка',
    campaign_settings: 'Параметры рассылки',
    email: 'Адресат',
    enter_name_of_autocast: 'Введите название авторассылки',
    enter_name_of_emails: 'Введите название рассылки',
    alert: 'Выберите параметр или группу параметров для создания рассылки',
    enter_value: 'Введите значение',
    choose_a_condition: 'Выберите условие',
    target_audience: 'Целевая рассылка',
    enter_motivation: 'Введите мотивацию',
    enter_instruction: 'Введите инструкцию',
    enter_test_mail_recipient_addresses: 'Введите адреса получателей тестовых рассылок',
    send_test_emails: 'Отправить тестовые письма',
    send_test_emails_for_autocast: 'Отправить тестовые письма для авторассылки',
    send_test_emails_for_selected_emails: 'Отправить тестовые письма для выбранных рассылок',
    enter_test_number: 'Введите номер теста',
    emails_creation_date: 'Дата создания рассылки',
    autocast_creation_date: 'Дата создания авторассылки',
    date_modified: 'Дата внесения изменений',
    sample: 'Выборка',
    emails_total: 'Всего писем',
    emails_delivered: 'Кол-во доставленных писем',
    pending: 'В процессе доставки',
    delivery_errors: 'Ошибки доставки',
    to_send: 'Ждут отправки',
    opened: 'Кол-во открытых писем',
    clicked: 'Переходов по ссылкам',
    web_preview: 'Веб-просмотр',
    recipients: 'Получатели',
    include_test_emails: 'Учитывать тестовые письма?',
    filters: 'Фильтры',
    date: 'Дата отправки',
    delivery_date: 'Дата доставки',
    dispatch_time: 'Время отправки',
    time_of_delivery: 'Время доставки',
    information_about_emails: 'Информация о рассылке',
    information_about_webpush: 'Информация о вебпуш-рассылке',
    webpush_total: 'Всего пушей',
    webpush_sent: 'Отправлено',
    webpush_shown: 'Показано',
    webpush_clicked: 'Кликов',
    webpush_closed: 'Закрыто без клика',
    webpush_dismissed: 'Закрыто без клика',
    webpush_crashed: 'Ошибки доставки',
    webpush_statuses: {
      new: 'Ждёт отправки',
      processing: 'В обработке',
      sent: 'Отправлено',
      shown: 'Показано',
      clicked: 'Клик',
      closed: 'Закрыто',
      dismissed: 'Закрыто',
      crashed: 'Ошибка'
    },
    information_about_autocast: 'Информация по авторассылке',
    take_into_account_activity_during_the_delay_period: 'Учитывать активность за период задержки',
    choose_a_condition_block: 'Выберите блок условий',
    multilead_is_created: 'Был создан мультилид',
    multilead_order_status: 'Наличие заказа',
    multilead_status: 'Статус мультилида',
    order_status: 'Статус заказа',
    visit_is_active: 'Визит активен',
    email_status: 'Статус рассылки',
    email_opened: 'Письмо открыто',
    email_clicked: 'Переход по ссылке',
    days_since_last_buy: 'Дней с последней покупки (если была)',
    days_since_purchase: 'Дней с покупки',
    offer_purchase_period: 'Период покупки товара',
    periodic_purchase_last_update: 'Дней с момента последней периодической покупки',
    days_before_next_predictable_periodic_purchase: 'Дней до следующей периодической покупки',
    days_after_skipped_periodic_purchase: 'Дней после пропущенной периодической покупки',
    not_attend: 'Не посещал(дней)',
    days_to_birthday: 'До дня рождения осталось (дней)',
    period_of_inactivity: 'Период неактивности',
    subscription_type: 'Тип подписки',
    email_contains: 'Почта',
    visit_type: 'Результат визита',
    form_submitted: 'Заполнена форма',
    visited_page: 'Посещенная страница',
    check_if_parameters_are_set_properly: 'Проверьте правильность параметров',
    check_if_parameters_are_set_properly_for_conditions_block:
      'Проверьте правильность параметров блока условий',
    error_save_autocast: 'Ошибка сохранения авторассылки',
    the_value_must_be_numeric: 'Значение должно быть числовым',
    enter_a_valid_email: 'Введите корректный email',
    no_template_selected: 'Не выбран шаблон',
    the_field_must_be_between_1_and_31: 'Поле должно быть от 1 до 31',
    the_field_must_be_between_1_and_23: 'Поле должно быть от 1 до 23',
    maximum_nesting_level: 'Максимальный уровень вложенности',
    maximum_number_of_blocks: 'Максимальное колличество блоков',
    maximum_number_of_conditions: 'Максимальное колличество условий',
    confirmation_of_subscription_is_required_for_sending_autocast:
      'Для отправки авторассылки требуется подтверждение подписки',
    purchased_offer: 'Имя купленного товара',
    unopened_mass_messages: 'Не открывал последних массовых рассылок',
    opened_mass_messages: 'Открывал последних массовых рассылок',
    last_mass_messages_count: 'Пришли письма по последним N рассылкам',
    multilead_message: 'Отправленная рассылка (мультилид)',
    filled_in: 'Поле заполнено',
    auto_cust: {
      limitation_email: 'Количество email может быть не более 10',
      choose_email: 'Необходимо указать хотя бы 1 почту',
      choose_ab_test: 'Выберите А/Б тест',
      send_test_success: 'Тестовая рассылка успешно отправлена',
      is_active: 'Активна',
      the_number_cannot_be_more_than: 'Число не может быть больше чем',
      the_maximum_number_of_characters: 'Максимальное количество символов',
      no_last_activity: 'Нет последней активности',
      autocast_has_been_archived: 'Авторассылка была архивирована',
      autocasts_has_been_archived: 'Авторассылки были архивированы',
      autocast_has_been_unarchived: 'Авторассылка была разархивирована',
      autocasts_has_been_unarchived: 'Авторассылки были разархивированы',
      autocast_has_been_activated: 'Авторассылка была активирована',
      autocasts_has_been_activated: 'Авторассылки были активированы',
      autocast_has_been_deactivated: 'Авторассылка была деактивирована',
      autocasts_has_been_deactivated: 'Авторассылки были деактивированы',
      unarchive_autocast: 'Разархивирвоать авторассылку',
      archive_autocast: 'Архивирвоать авторассылку',
      deactivate_autocast: 'Деактивировать авторассылку',
      active_autocast: 'Активировать авторассылку',
      must_select_at_least_1_autocast: 'Необходимо выбрать хотя бы 1 авторассылку',
      selected_autocast: 'Выбрано авторассылок',
      deactivate: 'Деактивировать',
      activate: 'Активировать',
      unarchive: 'Разархивировать',
      archive: 'Архивировать',
      show_archived_mailing_campaigns: 'Показать архивированные авторассылки',
      hide_archived_mailing_campaigns: 'Скрыть архивированные авторассылки',
      add_a_condition: 'Добавить условие',
      add_a_conditions_block: 'Добавить блок условий',
      paid: 'Оплачен',
      submitted: 'Оформлен',
      delivered: 'Доставлен',
      cancelled: 'Отменен',
      daily: 'Ежедневная',
      visits: 'Визитная',
      view: 'Просмотр товаров',
      cart: 'Добавление в корзину',
      pre_order: 'Начало заказа',
      order: 'Заказ',
      category_view: 'Просмотр категорий',
      unavailable_view: 'Просмотр недоступных товаров',
      in_stock: 'В наличии',
      discount: 'Снижение цены',
      day_of_week: 'Дни недели',
      day_of_month: 'Дни месяца',
      monday: 'Понедельник',
      tuesday: 'Вторник',
      wednesday: 'Среда',
      thursday: 'Четверг',
      friday: 'Пятница',
      saturday: 'Суббота',
      sunday: 'Воскресенье',
      starts_with: 'Начинается с',
      does_not_start_with: 'Нет в начале',
      did_not_visit_in_days: 'Не посещал(дней)',
      statistics_for_ab_testing: 'Статистика по А/Б тестам',
      lacking_ab_testing: 'Нет А/Б тестов',
      enter_day_of_month: 'Введите число месяца',
      copy_autocast: 'Копировать авторассылку | Копировать авторассылки | Копировать авторассылки',
      autocast_with_that_name_already_exists: 'Авторассылка с таким именем уже существует',
      autocast_successfully_copied: 'Авторассылка успешно скопирована',
      autocasts_successfully_copied: 'Авторассылки успешно скопированы',
      enter_name_of_new_autocast:
        'Введите название новой авторассылки | Введите названия новых авторассылок | Введите названия новых авторассылок',
      default_values: 'Значения по умолчанию',
      set_default_values: 'Задать значения по умолчанию',
      defaults_values_changed: 'Значения по умолчанию изменены',
      apply_defaults_values: 'Применить значения по умолчанию',
      apply_defaults_values_question:
        'Вы уверены, что хотите применить значения по умолчанию к выбранной авторассылке | Вы уверены, что хотите применить значения по умолчанию к выбранным авторассылкам | Вы уверены, что хотите применить значения по умолчанию к выбранным авторассылкам',
      selected_autocast: 'Выбранные авторассылки',
      you_must_set_at_least_one_default_value:
        'Необходимо задать как минимум одно значение по умолчанию',
      autocast_successfully_updated: 'Авторассылка успешно обновлена',
      autocasts_successfully_updated: 'Авторассылки успешно обновлены',
      delete_autocast: 'Удалить выбранные авторассылки',
      delete_autocast_title: 'Удаление авторассылок',
      delete_autocast_success: 'Авторассылки успешно удалены',
      email_statuses: {
        delivered: 'Доставлено',
        dropped: 'Ошибка доставки',
        opened: 'Открыто',
        new: 'Ждут отправки',
        sent: 'Попытка доставки',
        crashed: 'Неудачная отправка',
        complained: 'Пожаловались'
      },
      linked_tools_warning: 'Некоторые авторассылки связаны с другими инструментами'
    },
    ab_test: {
      active_ab_testing: 'Активных А/Б тестов',
      ab_testing: 'А/Б тестирование',
      autocast: 'Авторассылка',
      create_ab_test: 'Создать A/Б тест',
      test_name: 'Название теста',
      required_field: 'Обязательное поле для заполнения',
      enter_a_valid_value: 'Введите корректное значение',
      mandatory_to_choose: 'Обязательное поле для выбора',
      validation_not_passed: 'Валидация не пройдена',
      no_change: 'Нет изменений',
      save_changes_to_autocast: 'Сохранить изменения в авторассылке',
      saving_changes: 'Сохранение изменений',
      amount_must_be_no_more: 'Сумарная сумма не может быть больше',
      data_saved: 'Данные сохранились'
    },
    message_campaign: {
      sender_mail: 'Почта отправителя',
      select_channel: 'Выберите канал рассылки',
      template_selection: 'Выбор шаблона',
      disable_banner_display: 'Отключить показ баннера при переходе по письму',
      segment_size: 'Размер сегмента',
      segmant_delay: 'Интервал между сегментами',
      single_address: 'Одиночный адрес',
      segment_name: 'Имя сегмента',
      lead_id: 'ID Лида',
      parameter_is_optional: 'Параметр не обязателен',
      segment_size_delay_condition:
        'Параметры размер сегмента и интервал между сегментами должны быть оба заполнены или оба пусты',
      create_email_question: 'Вы уверены, что хотите создать рассылку',
      error_create_email: 'Ошибка создания рассылки',
      email_success_created: 'Рассылка успешно создана',
      network_error_check_manually: 'Произошла сетевая ошибка. Рассылка могла быть создана успешно. Проверьте список рассылок или попробуйте создать еще раз.',
      promocodes: 'Выбор категории промокода',
      promocode_in_template: 'В шаблоне есть промокод',
      segment_empty: 'Сегмент пуст',
      all_unsubscribed: 'Все отписаны в этом списке клиентов',
      missing_promocode_variable: "Переменная 'promocode_text' отсутствует в шаблоне",
      category_not_exist: 'Категория не существует',
      not_enough_promocodes: 'Недостаточно промокодов: {0}. Получателей: {1}, Промокодов: {2}',
      not_enough_promocodes_for_start: 'Недостаточный лимит для старта данной массовой рассылки',
      delete_no_permission: 'Нет прав на удаление этой рассылки',
      delete_not_found: 'Рассылка не найдена'
    },
    widgets: {
      error_config_file: 'Неверный формат файла конфига',
      missing_widget_type: 'В загружаемом файле отсутствует тип виджета',
      error_widget_type: 'Неверный тип виджета',
      export_config_success: 'Конфиг успешно экспортирован',
      import_config: 'Импортировать конфиг',
      export_config: 'Экспортировать конфиг',
      delete_widget: 'Удалить виджет | Удалить виджеты | Удалить виджеты',
      confirm_popup_delete_body_text:
        'Вы уверены, что хотите удалить выбранный виджет | Вы уверены, что хотите удалить выбранные виджеты | Вы уверены, что хотите удалить выбранные виджеты',
      copy_widget: 'Копировать виджет | Копировать виджеты | Копировать виджеты',
      confirm_popup_copy_body_text:
        'Введите название нового виджета | Введите названия новых виджетов | Введите названия новых виджетов',
      name_selected_widget:
        'Название выбранного виджета | Названия выбранных виджетов | Названия выбранных виджетов',
      action_selection: 'Выбор действия',
      actions_not_available_until_you_select_widgets:
        'Действия недоступны пока вы не выбрали виджеты',
      widget_name: 'Название виджета',
      active: 'Активен',
      not_active: 'Не активен',
      launch_date: 'Дата запуска',
      activate_widget: 'Активировать виджет',
      deactivate_widget: 'Деактивировать виджет',
      confirm_popup_activate_body_text: 'Вы уверены, что хотите активировать выбранный виджет',
      confirm_popup_deactivate_body_text: 'Вы уверены, что хотите деактивировать выбранный виджет',
      confirm_popup_activate_widgets_body_text: 'Вы уверены, что хотите активировать выбранные виджет',
      confirm_popup_deactivate_widgets_body_text: 'Вы уверены, что хотите деактивировать выбранные виджет',
      widget: 'Виджет',
      enter_widget_name: 'Введите название виджета',
      widget_type: 'Тип виджета',
      widget_creation: 'Создание виджета',
      widget_editing: 'Редактирование виджета',
      json_config: 'JSON конфиг',
      widget_on: 'Виджет включен',
      widget_off: 'Виджет выключен',
      widgets_on: 'Виджеты включены',
      widgets_off: 'Виджеты выключены',
      basic_settings: 'Основные настройки',
      variables: 'переменные',
      code: 'код',
      triggers: 'Триггеры',
      timer_from_the_beginning_of_the_visit: 'Таймер от начала визита (в секундах)',
      choose_display_conditions: 'Выберите условия показа',
      widget_group: 'Группа виджетов',
      trigger: 'Триггер',
      timer: 'Таймер (в секундах)',
      value: 'Значение',
      idle_timer: 'Таймер неактивности (в секундах)',
      mouse_out: 'Вывод мышки за границы экрана',
      localStorageKey: 'Ключ LocalStorage',
      parameters: 'Параметры',
      cookie: 'Куки',
      localstorage_variable: 'LocalStorage переменная',
      global_variable: 'Глобальная переменная',
      type: 'Тип',
      select_type: 'Выберите тип',
      select_name: 'Выберите имя',
      operator: 'Оператор',
      page_url: 'Путь к странице',
      pages_viewed: 'Просмотренные страницы',
      widget_shown: 'Виджет был показан',
      more: 'Больше',
      less: 'Меньше',
      contain_regexp: 'Содержит RegExp',
      not_contain_regexp: 'Не содаржит RegExp',
      name_of_new_widget: 'Имя нового виджета',
      widget_was_removed: 'Виджет успешно удален',
      widgets_was_removed: 'Виджеты успешно удалены',
      variable_assignment: 'Назначение переменной',
      variable_name: 'Имя переменной',
      widget_updated_successfully: 'Виджет успешно обновлен',
      widget_locked_by_another_user: 'Виджет уже редактируется другим пользователем',
      widget_lock_error: 'Не удалось заблокировать виджет',
      no_abtests: 'А/Б тесты отсутствуют',
      active_abtests: 'Активные тесты',
      finished_abtests: 'Завершенные тесты',
      no_finished_abtests: 'Завершенные тесты отсутствуют',
      start_date: 'Дата запуска',
      activity_period: 'Период активности',
      test_statistics: 'Статистика теста',
      metric: 'Метрика',
      finish_test: 'Завершить тест',
      finishing_abtest: 'Завершение теста "{name}"',
      finish_abtest_hint: 'Выберите виджеты, которые вы хотите оставить в работе после окончания теста.\nПо-умолчанию все виджеты, участвующие в тесте, деактивируются при завершении теста.',
      keep_in_work: 'Оставить в работе',
      abtest_successfully_finished: 'А/Б тест успешно завершен',
      abtest_finish_error: 'Не удалось завершить А/Б тест',
      abtest_stats_error: 'Не удалось загрузить статистику теста',
      stats_metrics: {
        popup_view: 'Показы окна',
        popup_view_3s: 'Показы окна 3 сек.',
        popup_view_10s: 'Показы окна 10 сек.',
        close: 'Закрытия',
        fill: 'Заполнения формы',
        conversion: 'Конверсия'
      },
      delete_test: 'Удалить тест',
      need_to_delete_widget_from_abtest: 'Нельзя удалить виджет, который участвует в А/Б тесте. Завершите тест и повторите попытку.',
      enter_test_name: 'Введите название теста',
      abtest_title: 'Выберите группу виджетов и название для добавления в тест',
      add_widget: 'Добавить виджет',
      share_of_show: 'Доля показа',
      no_widgets: 'Виджеты отсутствуют',
      all_tests_must_contain_widgets: 'Тест должен содержать минимум 2 виджета',
      not_all_share_show_widget_current: 'Сумма долей показа теста должна быть равно 100',
      are_you_sure_you_want_to_remove_abtest: 'Вы уверены что хотите удалить А/Б тест',
      removing_abtest: 'Удаление А/Б теста',
      abtest_successfully_deleted: 'А/Б тест успешно удален',
      name_selected_abtest: 'Название выбранного А/Б теста',
      abtest_saved: 'А/Б тест сохранен',
      choose_value: 'Выберите значение',
      activate_at_least_two_widgets: 'Активируйте минимум два виджета',
      fill_in_empty_test: 'Заполните пустой тест',
      widget_name_is_exist: 'Виджет с таким именем уже существует',
      selector: 'Селектор',
      contains_on_the_page: 'Содержиться на странице',
      not_contains_on_the_page: 'Не содержиться на странице'
    },
    alerts: {
      user_alerts: 'Пользовательские оповещения',
      history: 'История',
      сreate_alert: 'Создать оповещение',
      user_alert: 'Пользовательское оповещение',
      alert_name: 'Название оповещения',
      user_alert_editor_notification_text:
        'Выберите параметр или группу параметров для создания оповещения',
      send_to_mail: 'Отправить на почту',
      alert_parameters: 'Параметры оповещения',
      sender: 'Отправитель',
      sender_email: 'Email отправителя',
      recepient_email: 'Email получателя',
      send_only_with_phone: 'Отправлять только при наличии телефона',
      send_again: 'Отправлять повторно',
      webhook_alert: 'Оповещение через веб-хук' ,
      number_of_visits: 'Количество визитов',
      lead_mail_is_correct: 'Почта лида корректна',
      delete_user_alert:
        'Удалить пользовательское оповещение | Удалить пользовательские оповещения | Удалить пользовательские оповещения',
      confirm_popup_delete_body_text:
        'Вы уверены, что хотите удалить выбранное пользовательское оповещение | Вы уверены, что хотите удалить выбранные пользовательские оповещения | Вы уверены, что хотите удалить выбранные пользовательские оповещения',
      name_selected_user_alert:
        'Название выбранного пользовательского оповещения | Названия выбранных пользовательских оповещений | Названия выбранных пользовательских оповещений',
      user_alert_was_removed: 'Пользовательское оповещение успешно удалено',
      user_alerts_was_removed: 'Пользовательские оповещения успешно удалены',
      user_alert_updated_successfully: 'Пользовательское оповещение успешно обновлено',
      activate_user_alert:
        'Активировать пользовательское оповещение | Активировать пользовательские оповещения | Активировать пользовательские оповещения',
      confirm_popup_activate_body_text:
        'Вы уверены, что хотите активировать выбранное пользовательское оповещение | Вы уверены, что хотите активировать выбранные пользовательские оповещения | Вы уверены, что хотите активировать выбранные пользовательские оповещения',
      user_alerts_updated: 'Пользовательские оповещения обновлены',
      user_alert_updated: 'Пользовательское оповещение обновлено',
      deactivate_user_alert:
        'Деактивировать пользовательское оповещение | Деактивировать пользовательские оповещения | Деактивировать пользовательские оповещения',
      confirm_popup_deactivate_body_text:
        'Вы уверены, что хотите деактивировать выбранное пользовательское оповещение | Вы уверены, что хотите деактивировать выбранные пользовательские оповещения | Вы уверены, что хотите деактивировать выбранные пользовательские оповещения',
      lead_name: 'Имя лида',
      lead_mail: 'Почта лида',
      lead_phone: 'Телефон лида',
      no_mail: 'Почта отсутствует',
      no_phone: 'Телефон отсутствует',
      delete_user_alert_notification:
        'Удалить уведомление пользовательского оповещения | Удалить уведомления пользовательского оповещения | Удалить уведомления пользовательского оповещения',
      confirm_popup_delete_notification_body_text:
        'Вы уверены, что хотите удалить выбранное уведомление | Вы уверены, что хотите удалить выбранные уведомления | Вы уверены, что хотите удалить выбранные уведомления',
      name_selected_user_alert_notification:
        'Название выбранного уведомления | Названия выбранных уведомлений | Названия выбранных уведомлений',
      notifications_deleted: 'Уведомления удалены',
      notification_deleted: 'Уведомление удалено',
      download_to_csv: 'Скачать в CSV',
      export_csv_user_alert_notification:
        'Отправить уведомление на почту | Отправить уведомления на почту | Отправить уведомления на почту',
      sort_field: 'Поле сортировки',
      sort_direction: 'Направление сортировки'
    },
    subscriptions: {
      product_subscriptions: 'Подписки на товары',
      description: 'Управление подписками пользователей на уведомления о скидках и доступности товаров',
      no_subscriptions: 'Подписок пока нет',
      no_subscriptions_description: 'Здесь будут отображаться подписки пользователей на уведомления о скидках и доступности товаров',
      subscription_type: 'Тип подписок',
      search_by: 'Поиск по',
      subscription_period: 'Период подписки',
      search: 'Найти',
      all_types: 'Все',
      price_drop: 'Скидка на товар',
      availability: 'Доступность товара',
      email: 'Почта',
      offer_name: 'Название товара',
      product: 'Товар',
      type: 'Тип',
      date: 'Дата подписки',
      time_added: 'Время добавления',
      time_activated: 'Время активации',
      actions: 'Действия',
      discount: 'Скидка',
      base_price: 'Стоимость',
      discount_size: 'Скидка',
      status: 'Статус',
      ready: 'Готов',
      not_ready: 'Не готов'
    },
    loyalty: {
      loyalty: 'Лояльность',
      rules: 'Правила',
      loyalty_categories: 'Лояльность - Категории',
      loyalty_rules: 'Лояльность - Правила',
      category_name: 'Имя категории',
      discount_in_percent: 'Скидка в %',
      discount_size: 'Размер скидки',
      create_new_category: 'Создать новую категорию',
      category_type: 'Тип категории',
      category_successfully_created: 'Категория успешно создана',
      delete_category: 'Удалить категорию',
      confirm_popup_delete_category_body_text: 'Вы уверены, что хотите удалить выбранную категорию',
      selected_category_name: 'Название выбранной категории',
      category_successfully_deleted: 'Категория успешно удалена',
      loyalty_category: 'Категория лояльности',
      amount_of_purchases: 'Сумма покупок',
      select_conditions: 'Выберете условия',
      value_must_be_integer_or_float: 'Значение должно быть целым или десятичным числом',
      rule_successfully_created: 'Правило успешно создано',
      delete_rule: 'Удалить правило',
      confirm_popup_delete_rule_body_text: 'Вы уверены, что хотите удалить выбранное правило',
      selected_rule_condition:
        'Условие выбранного правила | Условия выбранного правила | Условия выбранного правила',
      rule_successfully_deleted: 'Правило успешно удалено'
    },
    business_rules: {
      title: 'Бизнес правило',
      add_business_rule: 'Добавить бизнес правило',
      name_of_business_rule: 'Название бизнес-правила',
      name_of_business_rule_mobile: 'Название',
      priority_rule: 'Приоритет правила',
      number_of_links: 'Количество связей',
      product: 'Товар',
      category: 'Категория',
      product_category: 'Категория товара',
      delete_rule: 'Удалить правило',
      confirm_popup_delete_body_text: 'Вы уверены, что хотите удалить выбранное правило',
      name_selected_rule: 'Название выбранного правила',
      edit_business_rule: 'Редактировать бизнес правило',
      create_business_rule: 'Создать бизнес правило',
      rule_removed: 'Бизнес правило удалено',
      configuration_selection: 'Выбор конфигурации для бизнес-правила',
      priority1: 'Первый приоритет',
      priority2: 'Второй приоритет',
      priority3: 'Третий приоритет',
      select_product: 'Выберите товар',
      select_category: 'Выберите категорию',
      apply_with_recommendation: 'Применить с рекомендациями',
      press_for_search: 'Нажмите для выбора',
      recommend_with_product: 'Рекомендовать с товаром',
      not_recommend_with_product: 'Не рекомендовать с товаром',
      recommend_with_category: 'Рекомендовать с категорией',
      not_recommend_with_category: 'Не рекомендовать с категорией',
      assigned_product_recommendation: 'Назначенная товарная рекомендация',
      start_searching_to_match: 'Начните поиск для соотнесения',
      products_found: 'Найденные товары',
      categories_found: 'Найденные категории',
      recommendations_found: 'Найденные рекомендации',
      warning_not_selected_product: 'Вы не выбрали товар для создания бизнес правила',
      warning_not_selected_category: 'Вы не выбрали категорию для создания бизнес правила',
      warning_not_selected_name_of_rule: 'Введите название для бизнес правила',
      changed_priority: 'Вы изменили приоритет',
      rule_created: 'Бизнес правило создано',
      rule_updated: 'Бизнес правило обновлено',
      no_rights: 'У Вас нет прав'
    },
    recommendation: {
      title: 'Рекомендация',
      activate: 'Активировать рекоммендацию',
      deactivate: 'Отключить рекоммендацию',
      confirm_popup_activate_body_text: 'Вы уверены что хотите активировать рекоммендацию',
      confirm_popup_deactivate_body_text: 'Вы уверены что хотите отключить рекоммендацию',
      name_selected: 'Название выбранной рекоммендации',
      name_of_service: 'Название сервиса',
      algorithm: 'Алгоритм',
      delete_recommendation: 'Удалить рекоммендацию',
      confirm_popup_delete_body_text: 'Вы действительно хотите удалить рекоммендацию',
      edit_recommendation: 'Редактировать рекоммендацию',
      alert_success: 'Вы изменили приоритет бизнес-правил',
      alert_danger: 'Бизнес-правило не может быть перемещенно в другую категорию',
      only_available: 'Рекомендовать только доступные товары',
      name_filter: 'Фильрация товаров по названию',
      price_filter: 'Фильрация товаров по сходству в цене',
      recommendation_on: 'Рекомендация включена',
      recommendation_off: 'Рекомендация выключена',
      recommendation_updated: 'Рекомендация обновлена'
    }
  },
  datepicker: {
    periods: 'Периоды',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    start_period: 'Начало',
    end_period: 'Конец'
  },
  intro_training: {
    welcome_aboard: 'Добро пожаловать на борт!',
    marketing_management: 'Управления маркетингом',
    start: 'Начать',
    later: 'Позже',
    start_module_question: 'Ознакомимся с функционалом продукта?',
    next: 'Далее',
    scene_leads_first_text:
      'Во вкладке "лиды" можно найти информацию о действиях каждого пользователя сайта который каким-либо образом оставил о себе какие-либо данные.',
    scene_leads_second_text:
      'Данные можно отсортировать по источникам трафика/дате появления/дате последнего визита/статусу и заполненной форме, так же здесь доступна информация о качестве лида (выкупает он заказы или нет) и быстрый доступ в карточку каждого клиента.',
    scene_leads_third_text:
      'Во вкладке "сегменты", лидов можно объединять по множеству условий и формировать выборки для создания индивидуальных предложений группам.',
    scene_instruments_first_text:
      'В данном разделе Вы найдете все доступные в данный момент инструменты. Актуальный рабочий статус также представлен в этом разделе.',
    scene_instruments_second_text:
      'Вы можете управлять работой инструментов в этом разделе. Добавлять новые виджеты, редактировать шаблоны писем и многое другое.',
    scene_instruments_third_text:
      'Сводная информация об эффективности каждого инструмента внутри каждого блока. Актуальная информация, обновляется в режиме реального времени.',
    scene_reports_first_text:
      'Все доступные отчеты собраны в одном разделе. Эффективность рекомендаций - продажи после клика на рекомендации. Доступны по каждому виджету в отдельности или полный отчет по всем виджетам.',
    scene_reports_second_text:
      'Отчет по рассылкам и авторассылкам – продажи после получения автоматического триггерного письма или письма отправленного в рамках массовой рассылки.',
    scene_reports_third_text:
      ' + бонус – сквозная аналитика – оцените эффективность каждого канала привлечения заказов.',
    scene_analytics_first_text:
      'В разделе Аналитика пользователю предоставляется возможность глубоко проанализировать результаты работы сервиса и в целом эффективность магазина.',
    scene_analytics_second_text:
      'Сводная аналитическая информация представлена в виде виджетов, здесь мы можем увидеть статистику визитов, динамику роста количества лидов, статистику по массовым и триггерным рассылкам и эффективности виджетов.',
    scene_analytics_third_text:
      'Каждый виджет можно развернуть и получить подробную картину каждого показателя, выбрать необходимый период, источник и другие настраиваемые параметры.',
    scene_color_switcher_title: 'Изменение темы интерфейса',
    scene_color_switcher_text:
      'Вы можете выбрать цветовое решение (тёмное или светлое) исходя из своих личных предпочтений, а так же переключаться между режимами во время рабочих сессий.',
    scene_settings_title: 'Блок "Настройки"',
    scene_settings_text:
      'В начале работы с сервисом "Leadhit" мы рекомендуем Вам перейти в модуль "Настройки" для удобного управления информацией и оповещениями. В модуле Вы также можете настроить доступ и активировать инструменты.',
    continue_later: 'Продолжить позднее',
    control_training_buttons_text: 'Вы можете управлять вводным туром при помощи кнопок'
  },
  tariffs: {
    information_about_tariffs: 'Информация о тарифах',
    functionality: 'Функциональность',
    per_month: 'в месяц',
    on_the_leadhit_side: 'На стороне LeadHit',
    compatibility_check: 'Проверка совместимости',
    forms_connection: 'Подключение форм',
    feed_check: 'Проверка фида',
    dns_preparation: 'Подготовка DNS',
    connecting_postmasters: 'Подключение постмастеров',
    cross_domain_integration: 'Кросс-доменная интеграция',
    finished_products: 'Готовые продукты',
    smartoffer: 'Смартоффер',
    mobile_smartoffer: 'Мобильный Смартоффер',
    triggered_mailings: 'Триггерные рассылки',
    abandoned_offer_view: 'Брошенный просмотр товара',
    wish_list: 'Виш-лист',
    collection_of_personal_data: 'Сбор персональных данных',
    abandoned_cart: 'Брошенная корзина',
    post_sale: 'Постпродажа',
    inactive_client: 'Неактивный клиент',
    subscribe_for_product_price_reduction: 'Подписка на снижение цены товара',
    subscribe_for_product_availability: 'Подписка на появление товара в наличии',
    average_bill_magnifier: 'Увеличитель среднего чека',
    social_proof: 'Социальное доказательство',
    additional_features: 'Дополнительные возможности',
    standard_widget_templates: 'Стандартные шаблоны виджетов',
    adaptation_of_widgets_for_the_clients_site: 'Адаптация виджетов под сайт клиента',
    individual_algorithm_for_displaying_widgets: 'Индивидуальный алгоритм показа виджетов',
    design_change: 'Изменение дизайна',
    algorithms_change: 'Изменение алгоритмов',
    ab_testing_of_widgets: 'А/Б тестирование виджетов',
    gamification: 'Геймификация',
    individual_widget_design: 'Индивидуальный дизайн виджетов',
    working_with_different_types_of_clients: 'Работа с разными типами клиентов',
    limitations: 'Ограничения',
    once_monthly: 'раз/месяц',
    abandoned_view_of_an_expensive_product: 'Брошенный просмотр дорогого товара',
    abandoned_view_of_products_out_of_stock: 'Брошенный просмотр товаров не в наличии',
    welcome_series: 'Welcome-серия',
    nps_poll: 'NPS-опрос',
    review: 'отзыв',
    abandoned_view_of_product_category: 'Брошенный просмотр категории товаров',
    products_of_regular_demand: 'Товары регулярного спроса',
    regular_new_products: 'Регулярные новинки',
    regular_promotions: 'Регулярные акции',
    transaction_mailings: 'Транзакционные рассылки',
    standard_email_templates: 'Стандартные шаблоны писем',
    visual_template_editor: 'Визуальный редактор шаблонов',
    adaptation_of_emails_to_the_clients_site: 'Адаптация писем под сайт клиента',
    algorithm_change: 'Изменение алгоритма',
    individual_algorithm_of_trigger_mailings: 'Индивидуальный алгоритм триггерных рассылок',
    ab_testing_of_triggered_mailings: 'А/Б тестирование триггерных рассылок',
    individual_promotional_codes_in_trigger_mailings:
      'Индивидуальные промокоды в триггерных рассылках',
    individual_recommendations_in_triggered_mailings:
      'Индивидуальные рекомендации в триггерных рассылках',
    limitation_on_the_number_of_emails_received_by_lead:
      'Ограничение количества получаемых лидом писем',
    support_of_regionalization: 'Поддержка региональности',
    individual_template_design: 'Индивидуальный дизайн шаблона',
    configure_transactional_mailings: 'Настройка транзакционных рассылок',
    limit_on_the_number_of_emails_sent_per_month_not_more_than:
      'Лимит по количеству отправленных писем в месяц, не более',
    welcome_series_consists_of_emails: 'Welcome-серия состоит из … писем',
    mass_mailings: 'Массовые рассылки',
    opportunities: 'Возможности',
    self_service_mailing: 'Самостоятельная рассылка',
    mailing_made_by_leadhit: 'Рассылка сделанная LeadHit',
    import_your_own_database: 'Импорт собственной базы',
    verification_of_the_imported_database: 'Верификация импортируемой базы',
    individual_recommendations_in_mass_mailings: 'Индивидуальные рекомендации в массовых рассылках',
    mailing_made_by_leadhit_per_month_no_more_if_you_need_more_often_contact_us:
      'Рассылка сделанная LeadHit, в месяц, не более (необходимо чаще - свяжитесь с нами)',
    verification_is_paid_additionally_depending_on_the_size_of_the_base:
      'Верификация оплачивается дополнительно, в зависимости от объема базы',
    import_is_possible_strictly_after_verification: 'Импорт возможен строго после верификации',
    recommendation_service_integration_by_api: 'Интеграция сервиса рекомендаций по API',
    service_integration_via_widget_by_leadhit: 'Интеграция сервиса через виджет (силами LeadHit)',
    setting_up_business_rules: 'Настройка бизнес-правил',
    algorithms: 'Алгоритмы',
    alarm_system: 'Система оповещений',
    abandoned_cart_notifications: 'оповещения о брошенных корзинах',
    ability_to_set_other_alerts: 'Возможность настройки других оповещений',
    project_support: 'Поддержка проекта',
    specialists: 'Специалисты',
    account_manager: 'Аккаунт-менеджер',
    designer: 'Дизайнер',
    copywriter: 'Копирайтер',
    layout_designer: 'Верстальщик',
    in_gap_tariff_support_available_on_ticket_system:
      'в тарифе Gap поддержка доступна по тикетной-системе',
    project_specialist_working_hours_are_limited_to_hours:
      'рабочие часы специалиста над проектом ограничены … часами',
    add_info_email_marketing:
      'Тариф не предусматривает работу специалистов над массовыми рассылкам. В случае заинтересованности в email-маркетинге (комплексном ведении массовых рассылок), свяжитесь с нами любым удобным для вас способом',
    analytics_and_statistics: 'Аналитика и статистика',
    tariff_selection: 'Выбор тарифа',
    lead_collection: 'Сбор лидов',
    converting_anonymous_visitors_to_leads: 'Превращение анонимных посетителей в лидов',
    base_collection: 'Сбор базы',
    returning_customers_to_the_funnel: 'Возврат клиентов в воронку',
    personalization_of_trigger_mailings: 'Персонализация триггерных рассылок',
    working_with_mobile_traffic: 'Работа с мобильным трафиком',
    personalization_of_email_marketing_and_website: 'Персонализация e-mail маркетинга и сайта',
    collecting_the_base_and_returning_customers_to_purchase:
      'Сбор базы и возврат клиентов к покупке',
    customizing_email_marketing: 'Персонализация е-mail маркетинга',
    customizing_the_site: 'Персонализация сайта',
    personalization_of_email_marketing_for_complex_scenarios:
      'Персонализация е-mail маркетинга по сложным сценариям',
    website_personalization_for_complex_scenarios: 'Персонализация сайта по сложным сценариям',
    full_customization_of_communications_with_clients:
      'Полная кастомизация коммуникаций с клиентами'
  },
  stripo_template_categories: {
    features: {
      title: 'Особенность',
      amp: 'AMP',
      accordion_menu: 'Меню аккордеон',
      css_animations: 'CSS анимации',
      carousel: 'Карусель',
      countdown_timer: 'Таймер',
      image_rollover: 'Ролловер эффект',
      video: 'Видео',
      gamification: 'Геймификация'
    },
    industries: {
      title: 'Индустрия',
      other: 'Другие',
      electronics: 'Электроника',
      clothes: 'Одежда',
      children_products: 'Детские товары',
      jewelry: 'Ювелирные изделия, украшения',
      art: 'Искусство',
      books: 'Книги',
      auto_moto: 'Авто-мото',
      construction: 'Строительство',
      animals: 'Домашние животные',
      products: 'Мебель, интерьер и DIY',
      ho_re_ca: 'Рестораны',
      tourism: 'Путешествия и туризм',
      transport: 'Логистика и доставка',
      beauty: 'Красота',
      consulting: 'Консалтинг',
      lawyers: 'Юридичское',
      software: 'Программное обеспечение и технологии',
      real_estate: 'Недвижимость',
      government: 'Государственные, общественные организации',
      beverages: 'Напитки',
      education: 'Образование',
      finance: 'Финансы',
      gadgets: 'Гаджеты',
      food: 'Еда',
      gifts_flowers_handmade: 'Мебель, интерьер и DIY',
      hotels: 'Гостиницы',
      photography: 'Фотография',
      publications_blogging: 'Подарки и ручная работа',
      sports: 'Спорт и фитнес',
      webinars: 'Вебинары',
      no_name: 'Без имени'
    },
    seasons: {
      title: 'Сезон',
      world_tourism_day: 'Всемирный день туризма',
      summer_time: 'Лето',
      cyber_monday: 'Кибер понедельник',
      halloween: 'Halloween',
      labor_day: 'День труда',
      back_to_school: 'Назад в школу',
      independence_day: 'День независимости',
      fathers_day: 'День отца',
      memorial_day: 'День памяти',
      mothers_day: 'День матери',
      easter: 'Пасха',
      st_patricks_day: 'День святого Патрика',
      st_valentines_day: 'День святого Валентина',
      christmas: 'Рождество',
      thanksgiving: 'Благодарности',
      black_friday: 'Черная пятница',
      new_year: 'Новый год',
      super_bowl: 'Супер Боул',
      womens_day: '8 марта',
      birthday: 'День рождения',
      global_shopping_festival: 'Всемирный фестиваль покупок',
      hanukkah: 'Ханука',
      spring: 'Весна',
      wedding_invitation: 'Приглашение на свадьбу'
    },
    types: {
      title: 'Тип',
      abandoned_cart: 'Abandoned Cart',
      alerts_and_notifications: 'Предупреждения и уведомления',
      apology: 'Извинения',
      cold_emails: 'Холодныe Emails',
      confirmation: 'Подтверждения',
      discount: 'Скидки',
      email_digest: 'Email дайджест',
      event_reminder: 'Напонимания',
      events: 'События',
      follow_up: 'Follow-up',
      holidays: 'Праздники',
      interactive: 'Интерактивные',
      internal: 'Внутренние',
      invitation: 'Приглашение',
      new_collection: 'Новая коллекция',
      order: 'Заказ',
      password_reset: 'Сброс пароля',
      post_purchase: 'После покупки',
      product_update: 'Обновление продукта',
      promo: 'Промо',
      retention_and_reactivation: 'Удержание и реактивация',
      sales: 'Распродажи',
      smart_elements: 'Smart элементы',
      survey_and_feedback: 'Опросы и отзывы',
      thank_you: 'Благодарноси',
      welcome: 'Добро пожаловать'
    }
  },
  web_push: {
    analytics: 'Аналитика',
    campaign_name: 'Название кампании',
    type: 'Тип',
    active: 'Активен',
    date_created: 'Дата создания',
    date_launched: 'Дата запуска',
    notification: 'Уведомление',
    audience: 'Аудитория',
    widget_on: 'Виджет включён',
    widget_off: 'Виджет выключен',
    tab_settings: 'Основные настройки',
    tab_preview: 'Предпросмотр',
    notification_content: 'Содержание уведомления',
    title_label: 'Заголовок',
    title_set_in_mailing: 'Заголовок задаётся при создании рассылки',
    body_label: 'Текст',
    body_required: 'Текст уведомления не может быть пустым',
    icon_url_label: 'Ссылка на иконку',
    image_url_label: 'Ссылка на изображение',
    link_url_label: 'Ссылка перехода',
    link_url_hint: 'Куда перейдёт пользователь при клике на уведомление',
    variables_hint: 'Переменные',
    test_send: 'Отправить тестовый пуш',
    test_sending: 'Отправка...',
    test_send_hint: 'Тестовый пуш придёт в этот браузер. Сначала браузер спросит разрешение на уведомления.',
    test_title_prompt: 'Введите заголовок тестового уведомления',
    test_title_required: 'Введите заголовок',
    test_permission_denied: 'Уведомления для кабинета заблокированы. Включите их в настройках сайта в адресной строке.',
    test_render_error: 'Не удалось подставить переменные в заголовок или текст',
    test_send_failed: 'Не удалось отправить тестовый пуш',
    test_no_permission: 'Нет права на отправку тестового вебпуша',
    test_send_success: 'Тестовый пуш отправлен! Проверьте уведомления в браузере.',
    test_send_error: 'Не удалось отправить тестовый пуш. Проверьте что Service Worker установлен и подписка активна.',
    triggers: 'Триггеры',
    trigger: 'Триггер',
    value: 'Значение',
    show_conditions: 'Выберите условия показа',
    add_condition: 'Добавить условие',
    saved: 'Сохранено',
    save_error: 'Не удалось сохранить шаблон',
    now: 'сейчас',
    recipients: 'Получатели',
    device: 'Устройство',
    activity: 'Активность',
    behavior_conditions: 'Условия по поведению',
    behavior_hint: 'Фильтрация по событиям на сайте',
    available_from_upper: 'Доступно с тарифа UPPER',
    available_from_prime: 'Доступно с тарифа PRIME',
    and: 'И',
    amount_rub: 'Сумма в рублях',
    category_name: 'Название категории',
    for_period: 'за',
    days_short: 'дн.',
    add: 'Добавить',
    back: 'Назад',
    save_audience: 'Сохранить аудиторию',
    estimated_reach: 'Расчётный охват',
    of_subscribers: 'из {total} подписчиков',
    breakdown: 'Разбивка',
    attribution_model: 'Модель атрибуции',
    tariff_limit: 'Лимит пушей по тарифу',
    limit_remaining: 'Осталось {n} отправок · обновляется 1-го числа',
    campaigns: 'Кампании',
    all_types: 'Все типы',
    campaign: 'Кампания',
    sent: 'Отправлено',
    delivered: 'Доставлено',
    clicks: 'Кликов',
    conversions: 'Конверсии',
    revenue: 'Выручка',
    status: 'Статус',
    total: 'Итого',
    details: 'Детализация',
    funnel: 'Воронка',
    attribution: 'Атрибуция',
    model: 'Модель',
    window: 'Окно',
    revenue_push: 'Выручка push',
    delivery_errors: 'Ошибки доставки',
    click_to_expand: 'Нажми на название кампании чтобы раскрыть детализацию'
  }
}



// WEBPACK FOOTER //
// ./src/languages/rus.js